import styled from "styled-components";

export const Container = styled.div`
  background-color: rgb(10 92 86);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Box = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

export const Logo = styled.img`
width: 7rem;
height: 6rem;
  margin-bottom: 5rem;
`;

export const ErrorMsg = styled.p`
font-size: 13px;
color: red;
text-align: center;
`


